import React from 'react';
import './Legal.css';

function Privacy() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1>Privacy Policy</h1>
        <p className="last-updated">Last Updated: December 2025</p>

        <section>
          <h2>Overview</h2>
          <p>Trackable ("we", "our", "the app") is committed to protecting your privacy. This policy explains what data we collect, how we use it, and your rights.</p>
        </section>

        <section>
          <h2>Data We Collect</h2>
          
          <h3>Health &amp; Fitness Data</h3>
          <ul>
            <li>Weight measurements and body metrics</li>
            <li>Nutrition and food logs</li>
            <li>Sleep tracking data</li>
            <li>Step counts and activity data</li>
            <li>Exercise and workout logs</li>
            <li>Fitness goals and progress</li>
          </ul>

          <h3>Account Data</h3>
          <ul>
            <li>Display name (optional)</li>
            <li>Email address (for authentication)</li>
            <li>Profile picture (optional)</li>
          </ul>

          <h3>Social Data (Optional Features)</h3>
          <ul>
            <li>Posts and comments you create</li>
            <li>Following/follower relationships</li>
            <li>Likes and interactions</li>
          </ul>
        </section>

        <section>
          <h2>How We Use Your Data</h2>
          
          <h3>Primary Uses:</h3>
          <ul>
            <li>Display your health data and track progress</li>
            <li>Generate personalized AI coaching insights</li>
            <li>Enable social features with friends (only data you choose to share)</li>
            <li>Sync with Apple Health (with your permission)</li>
          </ul>

          <h3>We DO NOT:</h3>
          <ul className="do-not-list">
            <li>Sell your personal data to third parties</li>
            <li>Share your health data with advertisers</li>
            <li>Use your data for targeted advertising</li>
            <li>Share data with insurance companies</li>
            <li>Use your data to train AI models</li>
          </ul>
        </section>

        <section>
          <h2>Data Storage &amp; Security</h2>
          <ul>
            <li>All data encrypted in transit (HTTPS/TLS)</li>
            <li>All data encrypted at rest (AES-256)</li>
            <li>Stored on secure AWS infrastructure</li>
            <li>Passwords never stored in plain text</li>
            <li>Regular security reviews</li>
          </ul>
        </section>

        <section>
          <h2>Your Rights</h2>
          <ul className="rights-list">
            <li>Access all your data anytime</li>
            <li>Export your data</li>
            <li>Delete your account and all data</li>
            <li>Update or correct your information</li>
            <li>Control what's shared socially</li>
          </ul>
        </section>

        <section>
          <h2>Data Retention</h2>
          <ul>
            <li><strong>Active accounts:</strong> Data retained while account is active</li>
            <li><strong>Deleted accounts:</strong> Data permanently deleted within 30 days</li>
          </ul>
        </section>

        <section>
          <h2>Third-Party Services</h2>
          <ul>
            <li><strong>AWS:</strong> Cloud infrastructure (data processor)</li>
            <li><strong>Amazon Bedrock:</strong> AI features (no data retention by AI)</li>
            <li><strong>Apple HealthKit:</strong> Health data sync (with your permission)</li>
          </ul>
        </section>

        <section>
          <h2>Children's Privacy</h2>
          <p>Trackable is not intended for users under 13. We do not knowingly collect data from children.</p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>We'll notify you of significant changes via email or in-app notification.</p>
        </section>

        <section>
          <h2>Contact</h2>
          <p>Questions? Email: <a href="mailto:support@trackable.fit">support@trackable.fit</a></p>
        </section>
      </div>
    </div>
  );
}

export default Privacy;
